export default "__VITE_ASSET__BlfYgoZY__"